import { datadogRum } from '@datadog/browser-rum';

export type ReducerUsageEvent = {
  actionName: string;
  storeName: string;
};

export function trackReducerUsage({ storeName, actionName }: ReducerUsageEvent) {
  datadogRum.addAction('effector.reducer', {
    store: storeName,
    action: actionName,
  });
}
